import { getLocalStorage } from '@core/storage'
import { StorageKeyEssentialEnum } from '@core/storage/types'
import type { PersistOptions } from '@core/zustand/persist'
import { persist } from '@core/zustand/persist'

import type { LiveHelperState, StateCreator } from './actions'

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}

export const ONE_TO_ONE_STORE_PERSIST_KEY = StorageKeyEssentialEnum.fw_otos

export const persistOptions: PersistOptions<
  LiveHelperState,
  Partial<LiveHelperState>
> = {
  name: ONE_TO_ONE_STORE_PERSIST_KEY,
  getStorage: () => getLocalStorage(),
  partialize: (state: LiveHelperState) => ({
    clientControls: state.clientControls,
    displayRecordingStatement: state.displayRecordingStatement,
    idleStateTextDismissTime: state.idleStateTextDismissTime,
    automatedMessage: state.automatedMessage,
    automatedMessageDismissTime: state.automatedMessageDismissTime,
    closeWidgetTime: state.closeWidgetTime,
    cameraAccessAllowedForVideoCallId: state.cameraAccessAllowedForVideoCallId,
  }),
  merge: (persistedState: LiveHelperState, currentState: LiveHelperState) => {
    return {
      ...currentState,
      ...persistedState,
    }
  },
}

/**
 * Adds persist middleware. See our custom `persistOptions` for more details.
 * https://github.com/pmndrs/zustand#persist-middleware
 */
export function addLocalStoragePersist(creator: StateCreator): StateCreator {
  return persist(creator, persistOptions) as StateCreator
}
